import environment from './public';

export default environment;
